import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import CcNode from '../../../services/models/CcNode';
import JobActionButton from '../../Jobs/JobActionButton';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import NodeResetReplicaForm from './NodeResetReplicaForm';

export default NodeResetReplicaButton;

export type NodeResetReplicaButtonProps = ButtonProps & {
    node: CcNode;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function NodeResetReplicaButton({
    node,
    children,
    onSuccess,
    ...rest
}: NodeResetReplicaButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.RESET_REPLICATION_SLAVE}
                    clusterId={node.clusterid}
                    extraKey={[node.hostname, node.port]}
                    {...rest}
                >
                    {children || 'Reset replica'}
                </JobActionButton>
            }
            form={<NodeResetReplicaForm node={node} onSuccess={onSuccess} />}
        />
    );
}
